module.exports = __webpack_public_path__ + "img/software_icon4.5060ab0d.png";